export const projects = [
    {
        "id": 1,
        "projectName": "To Done",
        "projectDescription": "To Done is not your average to-do app. While it is built with the essential features of a to-do app, it will ultimately do so much more.",
        "projectSrc": "images/projects/to-done.png",
        "projectUrl": "https://github.com/ltdelia/to-done",
        "projectSkills": ["react", "material", "firebase", "github pages", "tailwind"]
    },
    {
        "id": 2,
        "projectName": "Telephone Translator",
        "projectDescription": "The Telephone Translator is a Command-Line Interface (CLI) that translates alphanumeric telephone numbers into their corresponding numeric numbers.",
        "projectSrc": null,
        "projectUrl": "https://github.com/ltdelia/telephone-translator",
        "projectSkills": ["typescript", "node.js"]
    },
    {
        "id": 3,
        "projectName": "Collect The Force",
        "projectDescription": "Star Wars: Collect the Force is a web game that incorporates a range of technologies.",
        "projectSrc": "images/projects/collectTheForce.png",
        "projectUrl": "https://github.com/ltdelia/StarWarsCollectTheForce",
        "projectSkills": ["bootstrap", "javascript", "jquery"]
    }
]